import { render } from "./EditorRKTK.vue?vue&type=template&id=6f55d906&scoped=true"
import script from "./EditorRKTK.vue?vue&type=script&lang=js"
export * from "./EditorRKTK.vue?vue&type=script&lang=js"

import "./EditorRKTK.vue?vue&type=style&index=0&id=6f55d906&scoped=true&lang=css"

import exportComponent from "C:\\Users\\6217025534\\Desktop\\vsts-agent-win-x64-2\\_work\\40\\s\\PASVue\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f55d906"]])

export default __exports__